import * as types from './constants';

// Edit Account Name
export const editAccountNameRequest = data => (
  { type: types.EDIT_ACCOUNT_NAME_REQUEST, payload: data }
);

export const editAccountNameDone = data => (
  { type: types.EDIT_ACCOUNT_NAME_DONE, payload: data }
);

export const editAccountNameFailed = errors => (
  { type: types.EDIT_ACCOUNT_NAME_FAILED, payload: errors }
);